<template>
  <div class="message-request-modal">
    <div class="message-request-wrapper">
      <a
        data-w-id="150735b1-3e6f-fc67-a109-a12e2e2f0ba7"
        class="link-block-5 w-inline-block"
        @click="cancel"
        href="#"
        ><img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt=""
      /></a>
      <div class="div-block-52">
        <h1 class="modal-heading">Message request</h1>
      </div>
      <p class="paragraph-7">
        This is the beginning of your conversation with
        <a class="link-9" href="#"
          ><span class="text-span-5">{{
            singleProfessional.customerName
          }}</span></a
        >. This first message will be treated as a request, until the
        professional accepts, you wont be able to send any more messages.
      </p>
      <div class="div-block-80">
        <div class="text-block-64">Your message</div>
        <textarea
          placeholder="Introduce yourself"
          maxlength="5000"
          id="field-2"
          name="field-2"
          data-name="field"
          class="textarea w-input"
          v-model="requestModel.messageRequestBody"
        ></textarea>
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div v-else class="button-15 w-button" @click="sendMessage">
        Send message
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MessageRequestRequest from "@/model/requests/MessageRequestRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";

export default {
  name: "MessageRequestModal",
  components: { BaseComponentLoader },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalInfo: state => state.professional.professionalInfo,
      singleProfessional: state => state.professional.singleProfessional,
      professionalId: state => state.professional.professionalId
    }),
    ...mapState(["loader"])
  },
  props: {
    cancel: Function
  },
  data() {
    return {
      requestModel: MessageRequestRequest.create
    };
  },
  methods: {
    sendMessage() {
      this.requestModel.messageRequestFrom = this.userInfo.customerId;
      this.requestModel.messageRequestTo = this.singleProfessional.professionalCustomerId;
      StoreUtils.dispatch(
        StoreUtils.actions.messageRequest.SEND_MESSAGE_REQUEST,
        this.requestModel
      ).then(() => {
        this.requestModel.messageRequestBody = null;
      });
    }
  }
};
</script>

<style scoped></style>
